import { IRootState } from '../../../../store'
import { IWoundCareState } from '../store/woundCare.types'

export const getWoundCareSelector = (state: IRootState): IWoundCareState => state.woundCare
